module.exports = __webpack_public_path__ + "static/img/glory.c045c2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/glory.jpg
// module id = Vt93
// module chunks = 1